import type {
    IDaDataGenders,
    IFrontGenders,
    IPartSuggestions,
    TStatePartByNamePart,
    IFrontNameParts,
    TStateNamePart,
} from './models';

export const DA_DATA_LAST_NAME = 'surname';
export const DA_DATA_FIRST_NAME = 'name';
export const DA_DATA_PATRONYMIC = 'patronymic';

export const FIO_LAST_NAME = 'lastName';
export const FIO_FIRST_NAME = 'firstName';
export const FIO_PATRONYMIC = 'patronymic';

export const SUGGESTION_LAST_NAME = 'lastNameSuggestions';
export const SUGGESTION_FIRST_NAME = 'firstNameSuggestions';
export const SUGGESTION_PATRONYMIC = 'patronymicSuggestions';

export const CONCAT_FIO_RULES = {
    [SUGGESTION_LAST_NAME]: [undefined, FIO_FIRST_NAME, FIO_PATRONYMIC],
    [SUGGESTION_FIRST_NAME]: [FIO_LAST_NAME, undefined, FIO_PATRONYMIC],
    [SUGGESTION_PATRONYMIC]: [FIO_LAST_NAME, FIO_FIRST_NAME, undefined],
};

export const PART_BY_SUGGESTION: { [a: string]: TStateNamePart } = {
    [SUGGESTION_LAST_NAME]: FIO_LAST_NAME,
    [SUGGESTION_FIRST_NAME]: FIO_FIRST_NAME,
    [SUGGESTION_PATRONYMIC]: FIO_PATRONYMIC,
};

/** QC - степень достоверности от DaData; 1 - не нашлось в справочнике */
export const QC_OK = '0';
export const QC_FAILED = '1';
export const QC_SUCCESS = '0';
export const QC_FAIL = '1';

export const GENDER_NONE = 'NONE';
export const GENDER_UNKNOWN = 'UNKNOWN';
export const GENDER_FEMALE = 'f';
export const GENDER_MALE = 'm';
export const GENDER_DADATA_FEMALE = 'FEMALE';
export const GENDER_DADATA_MALE = 'MALE';

/** в зависимости от части имени составляется соответствующий кусок Стейта */
export const namePartStateConfig: TStatePartByNamePart = {
    [DA_DATA_LAST_NAME]: ({ suggestions, value }: IPartSuggestions) => ({
        lastName: value,
        lastNameSuggestions: suggestions,
        currentSuggestions: SUGGESTION_LAST_NAME,
    }),
    [DA_DATA_FIRST_NAME]: ({ suggestions, value }: IPartSuggestions) => ({
        firstName: value,
        firstNameSuggestions: suggestions,
        currentSuggestions: SUGGESTION_FIRST_NAME,
    }),
    [DA_DATA_PATRONYMIC]: ({ suggestions, value }: IPartSuggestions) => ({
        patronymic: value,
        patronymicSuggestions: suggestions,
        currentSuggestions: SUGGESTION_PATRONYMIC,
    }),
};

export const daDataToFrontGenders: IFrontGenders = {
    [GENDER_DADATA_FEMALE]: GENDER_FEMALE,
    [GENDER_DADATA_MALE]: GENDER_MALE,
    [GENDER_NONE]: GENDER_NONE,
    [GENDER_UNKNOWN]: GENDER_UNKNOWN,
};

export const frontToDaDataGenders: IDaDataGenders = {
    [GENDER_FEMALE]: GENDER_DADATA_FEMALE,
    [GENDER_MALE]: GENDER_DADATA_MALE,
    [GENDER_NONE]: GENDER_NONE,
    [GENDER_UNKNOWN]: GENDER_UNKNOWN,
};

export const daDataNamesToFrontNames: IFrontNameParts = {
    [DA_DATA_LAST_NAME]: FIO_LAST_NAME,
    [DA_DATA_FIRST_NAME]: FIO_FIRST_NAME,
    [DA_DATA_PATRONYMIC]: FIO_PATRONYMIC,
};

/** Задержка запроса к дадате*/
export const DEFAULT_REQUEST_DELAY = 300;
export const DEFAULT_REQUEST_MIN_LENGTH = 0;
